import { useQuery } from '@tanstack/react-query'

import { FeatureFlagsSchema } from '@/db/featureFlags/schema'
import { supabase } from '@/integrations/supabase/client'
import { getEnvironmentConfig } from '@/lib/environment'

export const useFeatureFlags = () => {
  const { isProduction } = getEnvironmentConfig()
  const environment = isProduction ? 'production' : 'development'

  const { data: flags } = useQuery({
    queryKey: ['featureFlags', environment],
    initialData: {},
    queryFn: async () => {
      const { data, error } = await supabase
        .from('feature_flags')
        .select('feature_key, enabled')
        .eq('environment', environment)

      if (error) {
        console.warn('Error fetching feature flags:', error)
        return {}
      }

      const parsedData = FeatureFlagsSchema.safeParse(data)

      if (!parsedData.success) {
        console.warn('Invalid feature flags schema', parsedData.error)
        return {}
      }

      return Object.fromEntries(
        parsedData.data.map(({ featureKey, enabled }) => [featureKey, enabled])
      )
    },
  })

  const isFeatureEnabled = (flag: string) => flags?.[flag] ?? false

  return { isFeatureEnabled }
}
